'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FieldListRow;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledFieldListRow = _styledComponents2.default.li.withConfig({
  displayName: 'FieldListRow__StyledFieldListRow',
  componentId: 'sc-1mn591k-0'
})(['display:flex;']);

function FieldListRow(props) {
  return _react2.default.createElement(StyledFieldListRow, props);
}